import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/api/client';

/**
 * Hook to handle app lifecycle events (web-only version)
 * Checks session validity when page becomes visible after being hidden
 */
export function useAppLifecycle(disabled = false) {
  const navigate = useNavigate();

  useEffect(() => {
    if (disabled) return;
    
    // Listen for page visibility changes (when user returns to tab)
    const handleVisibilityChange = async () => {
      if (!document.hidden) {
        // Page became visible - check session validity
        console.log('[App Lifecycle] Page became visible, checking session...');
        
        try {
          await api.get('/auth/me');
          console.log('[App Lifecycle] Session is valid');
        } catch (error) {
          console.log('[App Lifecycle] Session expired or invalid, redirecting to login...');
          
          // Clear any stored session data
          localStorage.removeItem('pos_login_date');
          localStorage.removeItem('pos_user_type');
          localStorage.removeItem('pos_user_info');
          localStorage.removeItem('pos_connection_status');
          
          // Redirect to login page
          navigate('/login', { replace: true });
        }
      }
    };

    // Add visibility change listener
    document.addEventListener('visibilitychange', handleVisibilityChange);
    console.log('[App Lifecycle] Visibility listener registered (web)');

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [navigate, disabled]);
}
